// test637
(637 && 0);
